import Repository from '../../repositories/RepositoryFactory';
const logLevelsRepository = Repository.get('logLevels');

export default {
	namespaced: true,
	state: {
		logLevels: [],
	},
	mutations: {
		SET_LOG_LEVELS (state, payload) {
			state.logLevels = payload;
		},
	},
	actions: {
		async getLogLevels ({ commit }) {
			commit('SET_LOG_LEVELS', (await logLevelsRepository.getLogLevels()).data);
		},
		async setLogLevel ({ commit }, body) {
			const res = await logLevelsRepository.setLogLevel(body);
			return res.data;
		},
	},
};
